/**
 * Sets of helpers dealing with the DOM and some of the recurrent functions needed in
 * Babylon.js
 */
var DomManagement = /** @class */ (function () {
    function DomManagement() {
    }
    /**
     * Checks if the window object exists
     * @returns true if the window object exists
     */
    DomManagement.IsWindowObjectExist = function () {
        return (typeof window) !== "undefined";
    };
    /**
     * Checks if the navigator object exists
     * @returns true if the navigator object exists
     */
    DomManagement.IsNavigatorAvailable = function () {
        return (typeof navigator) !== "undefined";
    };
    /**
     * Check if the document object exists
     * @returns true if the document object exists
     */
    DomManagement.IsDocumentAvailable = function () {
        return (typeof document) !== "undefined";
    };
    /**
     * Extracts text content from a DOM element hierarchy
     * @param element defines the root element
     * @returns a string
     */
    DomManagement.GetDOMTextContent = function (element) {
        var result = "";
        var child = element.firstChild;
        while (child) {
            if (child.nodeType === 3) {
                result += child.textContent;
            }
            child = (child.nextSibling);
        }
        return result;
    };
    return DomManagement;
}());
export { DomManagement };
//# sourceMappingURL=domManagement.js.map